<template>
    <div class="mirror">
        <!-- 间隔层 start -->
        <div class="ly-note--edge"></div>
        <!-- 间隔层  end  -->              
        <textarea v-model="textareaText" class="ly-note--textarea" @blur="textareaBlur" ref="textarea" v-show="isEdit"></textarea>
        <!-- <hr/> -->
        <div class="mirror-lines" v-show="!isEdit">
            <!-- 镜像域的光标 start -->
            <div class="mirror-cursors" v-show="polishShow">
                <div class="mirror-cursor" :style="{top: rowIndex * 50 + 'px', left: cursorLeft + 'px'}"></div>
            </div>
            <!-- 镜像域的光标  end  -->
            <!-- 多行文本显示区域 start -->
            <div class="mirror-code">
                <pre class="mirror-line" v-for="(el, i) in list" :key="i" :class="['pre_' + i]" @mouseup="handleMouseup(i)""><span v-if="el.length > 0">{{el}}</span><span v-else>&nbsp;</span></pre>
            </div>
            <!-- 多行文本显示区域  end  -->
            <!-- 隐藏域显示的文本，用于计算字符宽度 start -->
            <div class="mirror-polish">
                <pre class="mirror-line"><span ref="polishSpan">{{polishTxt}}</span></pre>
            </div>
            <!-- 隐藏域显示的文本，用于计算字符宽度  end  -->
        </div>
    </div>
</template>
<script>
    import RangFn from './rangFn'
    /**
     * 文本域镜像显示
     */
    export default {
        props: {
            value: {
                type: Array,
                default: _ => []
            } // 绑定的数据，分隔后的字符串集合
        },
        mixins:[RangFn],
        data () {
            return {
                isEdit: false, // 标识是否是编辑模式
                textHistory: [], // 记录历史的文本，用于ctrl+z
                textareaText: '', // 实际的操作文本
                cursorLeft: 0, // 光标左侧距离 
                polishTxt: '', // 用于计算宽度的文本
                list: [],
                polishShow: false, // 光标的显示控制
                start: 0, // 鼠标选取的初始位置
                end: 0, // 鼠标选取的结束位置
                rowIndex: 0, // 行索引
                colIndex:0, // 列索引
                textareaDom: null,
                isKeyZ: false // 标识是否是撤销引起的文本变化
            }
        },
        watch: {
            textareaText (txt) {
                if (this.textareaDom) {
                    let len = txt.split('\n').length
                    this.setTextareaHeight(len)
                }
            }
        },
        created () {
            this.list = this.value
            // 文本合并
            this.textareaText = this.list.join('\n')     
            // 回车事件的监听
            this.$eventHub.$on('NOTE_ENTER', this.enterFn)
            // 删除事件的监听
            this.$eventHub.$on('NOTE_DELETE', this.deleteFn)
            // 空格事件的监听
            this.$eventHub.$on('NOTE_SPACE', this.spaceFn)
            // 定位的监听
            this.$eventHub.$on('NOTE_POINT', this.pointFn)
            // 鼠标失去焦点的监听
            this.$eventHub.$on('NOTE_MOUSE_BLUR', this.mouseBlurFn)
            // 撤销事件ctrl+z
            this.$eventHub.$on('NOTE_KEYZ', this.keyzFn)
        },
        mounted () {
            this.textareaDom = this.$refs.textarea
        },
        methods: {
            /**
             * 设置textarea的高度
             */
            setTextareaHeight (len) {
                if (!this.textareaDom) return
                if (this.heightTimer) clearTimeout(this.heightTimer)
                this.heightTimer = setTimeout(() => {
                    this.textareaDom.style.height = len * 50 + 'px'
                }, 50)
            },
            /**
             * 回车的事件监听
             */
            enterFn () {
                this.updateText('\n')
            },
            /**
             * 删除键的监听
             * 删除时要知道所在行，师傅存在当前end索引长度
             */
            deleteFn () {
                // 获取当前行的列长度
                let currStr = this.list[this.rowIndex]
                let colLength = currStr.length
                if (colLength < this.colIndex) {
                    return 
                }
                this.updateText('', this.colIndex - 1)
            },
            /**
             * 空格键的监听
             */
            spaceFn () {
                this.updateText(' ')
            },
            /**
             * 根据事件同步更新字符串
             * @param start 字符鼠标前段内容
             * @param space   字符拼接中间加入的内容
             */
            updateText (space = '', start = this.colIndex, end = this.colIndex) {
                let txt = ''
                for (let i = 0, len = this.list.length; i < len; i++) {
                    let str = this.list[i] // 当前文本
                    let enter = i > 0 ? '\n' : '' // 换行符号
                    if (i === this.rowIndex) {
                        if (this.colIndex > 0) {
                            str = str.substring(0, start) + space + str.substring(end, str.length)
                        } else {
                            str = space + str.substring(end, str.length)
                            enter = space.length > 0 ? enter : ''
                        }
                    }
                    txt = txt + enter + str
                }
                // 记录文本历史
                this.textHistory.push(this.textareaText)    
                // 字符串拼接
                this.textareaText = txt
                // 分割文本  
                this.spiltText()
            },
            /**
             * 文本的分割
             */
            spiltText () {
                // 分隔
                this.list = this.textareaText.split('\n')
                // 回传分隔后的数据
                this.$emit('input', this.list)
            },
            /**
             * 文本定位的监听
             */
            pointFn (point) {
                this.start = point.start
                this.end = point.end
                this.rowIndex = point.row
                this.colIndex = point.col
                // 计算光标位置
                this.countCursorLeft()
            },
            /**
             * 计算光标左侧距离
             */
            countCursorLeft () {
                if (this.colIndex >= 0 && this.rowIndex <= this.list.length) {
                    let str = this.list[this.rowIndex]
                    this.polishTxt = str.substring(0, this.colIndex)
                    this.$nextTick(() => {
                        this.cursorLeft = this.$refs.polishSpan.offsetWidth
                    })
                }
                // 鼠标的闪烁设置
                this.mouseBlurFn()
                this.inter = setInterval(() => {
                    this.polishShow = !this.polishShow
                }, 500)
            },
            /**
             * 鼠标失去焦点的处理
             */
            mouseBlurFn () {
                // 停止光标显示
                if (this.inter) clearInterval(this.inter)
                this.polishShow = false
            },
            /**
             * 鼠标点击的事件监听
             */
            handleMouseup (index) {
                this.isEdit = true
                this.$nextTick(() => {
                    // 计算光标的位置
                    let pos = 0
                    for (let i = 0; i <= index; i++) {
                        pos += this.list[i].length
                    }
                    // 设置textarea中的光标位置
                    if (this.textareaDom.setSelectionRange) {
                        this.textareaDom.focus()
                        this.textareaDom.setSelectionRange(pos, pos)
                    }
                    // 设置textarea的高度
                    this.setTextareaHeight(this.list.length)
                })
            },
            /**
             * textarea失去焦点的处理
             */
            textareaBlur () {
                this.isEdit = false
                this.spiltText()
            },
            /**
             * 撤销事件的处理
             */
            keyzFn () {
                if (this.textHistory.length > 0) {
                    this.isKeyZ = true
                    let last = this.textHistory.length - 1 // 最后一个元素的索引
                    this.textareaText = this.textHistory[last]
                    // 分割文本
                    this.spiltText()
                    // 删除最后一个元素
                    this.textHistory.splice(last, 1)
                }
            }
        },
        destroyed () {
            // 销毁事件的监听
            // 回车事件的监听
            this.$eventHub.$off('NOTE_ENTER', this.enterFn)
            // 删除事件的监听
            this.$eventHub.$off('NOTE_DELETE', this.deleteFn)
            // 空格事件的监听
            this.$eventHub.$off('NOTE_SPACE', this.spaceFn)
            // 定位的监听
            this.$eventHub.$off('NOTE_POINT', this.pointFn)
            // 鼠标失去焦点的监听
            this.$eventHub.$off('NOTE_MOUSE_BLUR', this.mouseBlurFn)
            // 撤销事件ctrl+z
            this.$eventHub.$off('NOTE_KEYZ', this.keyzFn)
        }
    }
</script>
<style>
    .mirror {
        height: 100%;
        padding-left: 32px;
        position: relative;
        color: #635752;
    }
    .mirror-lines {
        position: relative;
        width: 100%;
        overflow-x: hidden;
    }
    /* 隐藏滚动条 */
    .mirror-lines::-webkit-scrollbar {
        display: none;
    }
    .mirror-cursors {
        position: relative;
        z-index: 3;
    }
    .mirror-cursor {
        position: absolute;
        border-left:1px solid #000;
        width: 1px;
        height: 20px;
        margin-top: 15px;
        background-color: rgba(0, 0, 255, .2)
    }
    .mirror-line {
        line-height: 50px;
        padding: 0;
        width: 1000px;
        font-family: Helvetica,"Microsoft Yahei",ST-Heiti,"Apple Color Emoji";
        font-size: 17px;
        word-break: keep-all;
        word-wrap: break-word;
        white-space: pre-wrap;
    }
    .mirror-polish pre span{
        visibility: hidden;
    }
</style>